import { useContext } from 'react'
import { useIntl } from 'react-intl'

import ContactContext from 'contexts/contactContext'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import TextLink from 'LuxKit/TextLink'

export function shouldShowGrandHyattBaliFutureDatesBanner(offerId: string) {
  return offerId === '006RF00000ZlOacYAF'
}

// TODO(HP-2743): Remove when no longer relevant.
function GrandHyattBaliFutureDatesBanner() {
  const contactContext = useContext(ContactContext)
  const intl = useIntl()

  return <MessageBanner
    kind="informational"
    heading={intl.formatMessage({
      id: 'lMHlWuhcOXQ3ASEdFEdV',
      defaultMessage: 'Want to travel between October 2027 and March 2028?',
      description: 'Banner heading for Grand Hyatt Bali offer directing customers to call Customer Support for future date bookings',
    })}
  >
    {intl.formatMessage({
      id: 'tVC9E-9Mx6QAyI-H2d5t',
      defaultMessage: 'Our friendly 24/7 Customer Support team is here to help. Call {localPhoneNumber} (international number {internationalPhoneNumber}).',
      description: 'Banner message for Grand Hyatt Bali offer directing customers to call Customer Support for future date bookings',
    }, {
      localPhoneNumber: <TextLink href={`tel:${contactContext.local.number}`}>{contactContext.local.humanReadable}</TextLink>,
      internationalPhoneNumber: <TextLink href={`tel:${contactContext.international.number}`}>{contactContext.international.humanReadable}</TextLink>,
    })}
  </MessageBanner>
}

export default GrandHyattBaliFutureDatesBanner
